export const UOF_CONSTANT = [0, 1, 1.6, 1.9, 2.2, 2.5];
